(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["end-mill-configurator"] && !Shopify.designMode) return;
  try {
    
(function(){
  var NAMES={p:'steel',m:'stainless steel',k:'cast iron',n:'aluminum and non-ferrous metals',s:'titanium and superalloys',h:'hardened steel'};
  var KEY='ls-em-build';
  function store(get,val){
    try{ if(get) return JSON.parse(localStorage.getItem(KEY)||'{}'); localStorage.setItem(KEY,JSON.stringify(val)); }catch(e){ return {}; }
  }
  function money(cents,fmt){
    var v=(cents/100).toFixed(2), parts=v.split('.'), withC=parts[0].replace(/\B(?=(\d{3})+(?!\d))/g,',')+'.'+parts[1];
    fmt=fmt||'$\u007b\u007bamount\u007d\u007d';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/,function(m,k){
      if(k==='amount_no_decimals') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g,',');
      if(k==='amount_with_comma_separator') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g,'.')+','+parts[1];
      return withC;
    });
  }

  function init(root){
    if(!root || root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready','1');
    var fmt=root.getAttribute('data-money-format');
    var tiers=(root.getAttribute('data-tiers')||'').split(',').filter(Boolean).map(function(t){var p=t.split(':');return {qty:+p[0],pct:+p[1]};});
    var top=tiers.length?tiers[tiers.length-1].qty:0;
    var state={mat:'all',type:'all'};
    var rows=[].slice.call(root.querySelectorAll('.em__row'));
    var groups=[].slice.call(root.querySelectorAll('.em__group'));
    var status=root.querySelector('.em__status');
    var empty=root.querySelector('.em__emptybody');
    var tray=root.querySelector('[data-tray]');
    var qv=root.querySelector('[data-qv]');
    var toast=root.querySelector('[data-toast]');
    var byId={};
    rows.forEach(function(r){ var id=r.getAttribute('data-id'); if(id) byId[id]=r; });
    var build=store(true)||{};
    Object.keys(build).forEach(function(id){ if(!byId[id] || byId[id].getAttribute('data-available')!=='true') delete build[id]; });
    var inCart=0, qvRow=null, toastTimer;

    /* ---------- Filters ---------- */
    function press(set,val){
      [].forEach.call(root.querySelectorAll('[data-set="'+set+'"]'),function(b){b.setAttribute('aria-pressed',b.getAttribute('data-val')===val?'true':'false');});
    }
    function apply(){
      var shown=0;
      rows.forEach(function(r){
        var okMat=state.mat==='all'||/^(good|ok)$/.test(r.getAttribute('data-r'+state.mat)||'');
        var okType=state.type==='all'||(' '+r.getAttribute('data-filter')+' ').indexOf(' '+state.type+' ')>-1;
        var vis=okMat&&okType; r.hidden=!vis; if(vis) shown++;
      });
      groups.forEach(function(g){ g.hidden=!g.querySelector('.em__row:not([hidden])'); });
      if(empty) empty.hidden=shown>0;
      if(state.mat==='all') root.removeAttribute('data-mat'); else root.setAttribute('data-mat',state.mat);
      var noun=shown===1?'tool':'tools';
      if(status) status.textContent= state.mat==='all'
        ? (state.type==='all'?'Showing all '+rows.length+' tools.':'Showing '+shown+' '+noun+'.')
        : shown+' '+noun+' rated good or OK for '+NAMES[state.mat]+'.';
    }

    /* ---------- Build ---------- */
    function setQty(id,q){
      q=Math.max(0,Math.min(99,q|0));
      if(q) build[id]=q; else delete build[id];
      store(false,build); paintRow(id); paintTray();
    }
    function paintRow(id){
      var r=byId[id]; if(!r) return;
      var q=build[id]||0, add=r.querySelector('.em__add'), step=r.querySelector('.em__step');
      if(!add||!step) return;
      add.hidden=q>0; step.hidden=q===0;
      r.querySelector('[data-qty]').textContent=q;
      r.classList.toggle('is-in',q>0);
    }
    function tierFor(n){ var t=null; tiers.forEach(function(x){ if(n>=x.qty) t=x; }); return t; }
    function paintTray(){
      if(!tray) return;
      var ids=Object.keys(build), qty=0, sub=0, list=tray.querySelector('[data-tray-list] ul');
      list.innerHTML='';
      ids.forEach(function(id){
        var r=byId[id], q=build[id], price=+r.getAttribute('data-price');
        qty+=q; sub+=q*price;
        var li=document.createElement('li'), a=document.createElement('span'), b=document.createElement('span');
        a.textContent=q+' × '+r.getAttribute('data-name')+(r.getAttribute('data-pn')?' ('+r.getAttribute('data-pn')+')':'');
        b.textContent=money(q*price,fmt); li.appendChild(a); li.appendChild(b); list.appendChild(li);
      });
      var total=qty+inCart, cur=tierFor(total), next=null;
      tiers.forEach(function(x){ if(!next && total<x.qty) next=x; });
      tray.hidden=qty===0;
      root.classList.toggle('has-tray',qty>0);
      tray.querySelector('[data-tray-count]').textContent=qty+(qty===1?' tool':' tools')+' in your set';
      var subTxt=money(sub,fmt);
      if(cur) subTxt+=' · est. '+money(Math.round(sub*cur.pct/100),fmt)+' off';
      tray.querySelector('[data-tray-sub]').textContent=subTxt;
      var fill=tray.querySelector('[data-tray-fill]');
      if(fill && top) fill.style.width=Math.min(100,total/top*100)+'%';
      [].forEach.call(tray.querySelectorAll('[data-tick]'),function(t){
        var q=+t.getAttribute('data-tick'); t.style.left=Math.min(100,q/top*100)+'%'; t.classList.toggle('is-hit',total>=q);
      });
      var msg=tray.querySelector('[data-tray-msg]'), txt='';
      var cartBit=inCart?' Counts '+inCart+(inCart===1?' end mill':' end mills')+' already in your cart.':'';
      if(!tiers.length) txt='';
      else if(next){
        var need=next.qty-total, word=need===1?'tool':'tools';
        txt=cur
          ? '<strong>'+cur.pct+'% off</strong> unlocked. Add <strong>'+need+' more '+word+'</strong> for '+next.pct+'% off.'
          : 'Add <strong>'+need+' more '+word+'</strong> to get <strong>'+next.pct+'% off</strong>.';
        txt+=cartBit;
      } else {
        txt='<strong>'+cur.pct+'% off</strong> unlocked on every end mill. Applied at checkout.'+cartBit;
      }
      msg.innerHTML=txt;
    }

    function refreshCart(cart){
      var p=cart?Promise.resolve(cart):fetch(root.getAttribute('data-cart-url')+'.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();});
      return p.then(function(c){
        inCart=0;
        (c.items||[]).forEach(function(it){ if(byId[String(it.variant_id)]) inCart+=it.quantity; });
        paintTray();
      }).catch(function(){});
    }

    function showToast(m,err,noLink){
      if(!toast) return;
      clearTimeout(toastTimer);
      toast.querySelector('[data-toast-msg]').textContent=m;
      toast.querySelector('[data-toast-link]').hidden=!!err||!!noLink;
      toast.classList.toggle('is-error',!!err);
      toast.hidden=false;
      toastTimer=setTimeout(function(){toast.hidden=true;},err?7000:5000);
    }

    function addToCart(){
      var btn=tray.querySelector('[data-act="cart"]');
      var items=Object.keys(build).map(function(id){return {id:+id,quantity:build[id]};});
      if(!items.length||btn.getAttribute('aria-busy')) return;
      btn.setAttribute('aria-busy','true'); btn.disabled=true;
      var bubble=document.getElementById('cart-icon-bubble');
      var body={items:items};
      if(bubble){ body.sections='cart-icon-bubble'; body.sections_url=window.location.pathname; }
      fetch(root.getAttribute('data-cart-add-url')+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify(body)})
        .then(function(r){return r.json().then(function(d){return {ok:r.ok,d:d};});})
        .then(function(res){
          if(!res.ok||res.d.status) throw new Error(res.d.description||res.d.message||'Could not add to cart.');
          if(bubble && res.d.sections && res.d.sections['cart-icon-bubble']){
            var doc=new DOMParser().parseFromString(res.d.sections['cart-icon-bubble'],'text/html').querySelector('.shopify-section');
            if(doc) bubble.innerHTML=doc.innerHTML;
          }
          if(root.getAttribute('data-after-add')==='cart'){ window.location.href=root.getAttribute('data-cart-url'); return; }
          var n=items.reduce(function(a,b){return a+b.quantity;},0);
          var ids=Object.keys(build); build={}; store(false,build); ids.forEach(paintRow);
          return fetch(root.getAttribute('data-cart-url')+'.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(cart){
            [].forEach.call(document.querySelectorAll('[data-cart-count]'),function(el){el.textContent=cart.item_count;});
            document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart:cart,source:'em'}}));
            refreshCart(cart);
            var t=tierFor(inCart);
            showToast('Added '+n+(n===1?' tool':' tools')+' to your cart.'+(t?' '+t.pct+'% off applies at checkout.':''));
          });
        })
        .catch(function(err){ showToast(err.message,true); })
        .finally(function(){ btn.removeAttribute('aria-busy'); btn.disabled=false; });
    }

    /* ---------- Hover video (desktop) ---------- */
    var canHover=window.matchMedia&&window.matchMedia('(hover:hover) and (pointer:fine)').matches;
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    if(canHover&&!reduce){
      rows.forEach(function(r){
        var src=r.getAttribute('data-video-sm'), th=r.querySelector('.em__thumb');
        if(!src||!th) return;
        th.addEventListener('mouseenter',function(){
          var v=th.querySelector('video');
          if(!v){ v=document.createElement('video'); v.muted=true; v.loop=true; v.playsInline=true; v.setAttribute('aria-hidden','true'); v.src=src; th.appendChild(v); }
          v.hidden=false; var p=v.play(); if(p&&p.catch) p.catch(function(){});
        });
        th.addEventListener('mouseleave',function(){ var v=th.querySelector('video'); if(v){ v.pause(); v.hidden=true; } });
      });
    }

    /* ---------- Quick view ---------- */
    function stage(item){
      var st=qv.querySelector('[data-qv-stage]'); st.innerHTML='';
      if(item.video){
        var v=document.createElement('video'); v.src=item.video; v.muted=true; v.loop=true; v.playsInline=true; v.autoplay=!reduce; v.controls=true;
        v.setAttribute('aria-label','360° view'); st.appendChild(v);
      } else {
        var i=document.createElement('img'); i.src=item.src; i.alt=item.alt||''; st.appendChild(i);
      }
    }
    function openQv(r){
      if(!qv||typeof qv.showModal!=='function'){ if(r.getAttribute('data-url')) window.location.href=r.getAttribute('data-url'); return; }
      qvRow=r;
      var g=[]; try{ g=JSON.parse(r.getAttribute('data-gallery')||'[]'); }catch(e){}
      var video=r.getAttribute('data-video');
      var items=(video?[{video:video}]:[]).concat(g);
      var th=qv.querySelector('[data-qv-thumbs]'); th.innerHTML='';
      items.forEach(function(it,i){
        var b=document.createElement('button'); b.type='button';
        b.setAttribute('aria-label',it.video?'360° video':'Image '+(i+1)); b.setAttribute('aria-current',i===0?'true':'false');
        if(it.video){ b.className='is-video'; b.textContent='360°'; } else { var im=document.createElement('img'); im.src=it.thumb; im.alt=''; b.appendChild(im); }
        b.addEventListener('click',function(){ [].forEach.call(th.children,function(c){c.setAttribute('aria-current','false');}); b.setAttribute('aria-current','true'); stage(it); });
        th.appendChild(b);
      });
      th.hidden=items.length<2;
      if(items.length) stage(items[0]); else qv.querySelector('[data-qv-stage]').innerHTML='';
      qv.querySelector('[data-qv-title]').textContent=r.getAttribute('data-name');
      qv.querySelector('[data-qv-pn]').textContent=r.getAttribute('data-pn')||'';
      qv.querySelector('[data-qv-specs]').textContent=r.getAttribute('data-specs')||'';
      var rm=r.querySelector('.em__rates-m'); qv.querySelector('[data-qv-rates]').innerHTML=rm?rm.innerHTML:'';
      var price=r.getAttribute('data-price'), avail=r.getAttribute('data-available')==='true';
      qv.querySelector('[data-qv-price]').textContent=price?money(+price,fmt):'';
      var add=qv.querySelector('[data-act="qv-add"]'); add.hidden=!avail;
      var link=qv.querySelector('[data-qv-link]'); link.hidden=!r.getAttribute('data-url'); link.href=r.getAttribute('data-url')||'#';
      qv.showModal();
    }
    if(qv){
      qv.addEventListener('close',function(){ var v=qv.querySelector('video'); if(v) v.pause(); qvRow=null; });
      qv.addEventListener('click',function(e){ if(e.target===qv) qv.close(); });
    }

    /* ---------- Clicks ---------- */
    root.addEventListener('click',function(e){
      var b=e.target.closest('[data-set]');
      if(b){ state[b.getAttribute('data-set')]=b.getAttribute('data-val'); press(b.getAttribute('data-set'),b.getAttribute('data-val')); apply(); return; }
      if(e.target.closest('[data-reset]')){ state.mat='all';state.type='all';press('mat','all');press('type','all');apply(); return; }
      var a=e.target.closest('[data-act]'); if(!a) return;
      var act=a.getAttribute('data-act'), r=a.closest('.em__row'), id=r&&r.getAttribute('data-id');
      switch(act){
        case 'add': setQty(id,1); var s=r.querySelector('[data-act="inc"]'); if(s) s.focus(); break;
        case 'inc': setQty(id,(build[id]||0)+1); break;
        case 'dec': setQty(id,(build[id]||0)-1); if(!build[id]){ var ad=r.querySelector('.em__add'); if(ad) ad.focus(); } break;
        case 'group':
          var g=a.closest('.em__group'), n=0;
          [].forEach.call(g.querySelectorAll('.em__row:not([hidden])'),function(x){
            var i=x.getAttribute('data-id'); if(i && x.getAttribute('data-available')==='true' && !build[i]){ build[i]=1; n++; paintRow(i); }
          });
          store(false,build); paintTray();
          showToast(n?'Added '+n+(n===1?' tool':' tools')+' to your set.':'Everything in this group is already in your set.',false,true);
          break;
        case 'toggle': setOpen(a.getAttribute('aria-expanded')!=='true', true); break;
        case 'view': openQv(r); break;
        case 'close': qv.close(); break;
        case 'qv-add': if(qvRow){ var qi=qvRow.getAttribute('data-id'); setQty(qi,(build[qi]||0)+1); qv.close(); showToast('Added '+qvRow.getAttribute('data-name')+' to your set.',false,true); } break;
        case 'list':
          var l=tray.querySelector('[data-tray-list]'), open=a.getAttribute('aria-expanded')==='true';
          a.setAttribute('aria-expanded',open?'false':'true'); l.hidden=open; break;
        case 'clear': var ids=Object.keys(build); build={}; store(false,build); ids.forEach(paintRow); paintTray(); break;
        case 'cart': addToCart(); break;
        case 'toast-close': toast.hidden=true; break;
      }
    });

    document.addEventListener('cart:updated',function(e){ if(!e.detail||e.detail.source!=='em') refreshCart(e.detail&&e.detail.cart); });
    window.addEventListener('pageshow',function(e){ if(e.persisted) refreshCart(); });

    /* ---------- Collapsible bar ---------- */
    var body=root.querySelector('.em__body'), tog=root.querySelector('[data-act="toggle"]');
    function setOpen(open,focus){
      if(!tog||!body) return;
      body.hidden=!open; tog.setAttribute('aria-expanded',open?'true':'false');
      var lab=tog.querySelector('[data-toggle-label]'); if(lab) lab.textContent=lab.getAttribute(open?'data-open':'data-closed');
      if(open) stick();
      if(open&&focus){ var f=body.querySelector('[data-set]'); if(f) f.focus({preventScroll:true}); }
    }
    var anchor=root.querySelector('.em__anchor');
    function fromHash(){ if(anchor&&location.hash==='#'+anchor.id) setOpen(true,false); }
    window.addEventListener('hashchange',fromHash); fromHash();
    document.addEventListener('click',function(e){
      var l=e.target.closest&&e.target.closest('a[href]'); if(!l||!anchor) return;
      if(l.getAttribute('href')==='#'+anchor.id){ setOpen(true,false); }
    });

    /* ---------- Sticky column labels under the site header ---------- */
    var siteHeader=null;
    ['sticky-header','.shopify-section-header-sticky','.shopify-section-group-header-group','#shopify-section-header','header.header','header'].some(function(sel){
      var el=document.querySelector(sel); if(el&&!root.contains(el)){ siteHeader=el; return true; } return false;
    });
    var ticking=false;
    function stick(){
      var top=0;
      if(siteHeader){
        var cs=getComputedStyle(siteHeader), r=siteHeader.getBoundingClientRect();
        var pinned=cs.position==='fixed'||cs.position==='sticky'||(siteHeader.parentElement&&/fixed|sticky/.test(getComputedStyle(siteHeader.parentElement).position));
        if(pinned&&r.bottom>0&&r.top<=1) top=Math.round(r.bottom);
      }
      root.style.setProperty('--em-sticky-top',top+'px');
      var th=root.querySelector('.em__table thead th');
      if(th){ var b=th.getBoundingClientRect(); root.classList.toggle('is-stuck',b.top<=top+1&&root.querySelector('.em__table').getBoundingClientRect().top<top); }
      ticking=false;
    }
    window.addEventListener('scroll',function(){ if(!ticking){ ticking=true; requestAnimationFrame(stick); } },{passive:true});
    window.addEventListener('resize',stick);
    stick();

    apply();
    Object.keys(build).forEach(paintRow);
    paintTray();
    refreshCart();
  }
  function boot(scope){
    if(scope && scope.matches && scope.matches('[data-em]')) { init(scope); return; }
    [].forEach.call((scope||document).querySelectorAll('[data-em]'),init);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){boot();}); else boot();
  document.addEventListener('shopify:section:load',function(e){boot(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["end-mill-kits"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root||root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready','1');
    var toast=root.querySelector('[data-ek-toast]'), timer;
    function show(msg,err){
      clearTimeout(timer);
      toast.querySelector('[data-ek-toast-msg]').textContent=msg;
      toast.querySelector('[data-ek-toast-link]').hidden=!!err;
      toast.classList.toggle('is-error',!!err); toast.hidden=false;
      timer=setTimeout(function(){toast.hidden=true;},err?7000:5000);
    }
    root.addEventListener('click',function(e){ if(e.target.closest('[data-ek-toast-close]')) toast.hidden=true; });
    root.addEventListener('submit',function(e){
      var f=e.target.closest('[data-ek-add]'); if(!f||root.getAttribute('data-after-add')==='cart') return;
      e.preventDefault();
      var btn=f.querySelector('button'); if(btn.disabled) return;
      btn.setAttribute('aria-busy','true'); btn.disabled=true;
      var data=new FormData(f), bubble=document.getElementById('cart-icon-bubble');
      if(bubble){ data.append('sections','cart-icon-bubble'); data.append('sections_url',location.pathname); }
      fetch(root.getAttribute('data-cart-add-url')+'.js',{method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:data})
        .then(function(r){return r.json().then(function(d){return {ok:r.ok,d:d};});})
        .then(function(res){
          if(!res.ok||res.d.status) throw new Error(res.d.description||res.d.message||'Could not add to cart.');
          if(bubble&&res.d.sections&&res.d.sections['cart-icon-bubble']){
            var s=new DOMParser().parseFromString(res.d.sections['cart-icon-bubble'],'text/html').querySelector('.shopify-section');
            if(s) bubble.innerHTML=s.innerHTML;
          }
          return fetch(root.getAttribute('data-cart-url')+'.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();});
        })
        .then(function(cart){
          [].forEach.call(document.querySelectorAll('[data-cart-count]'),function(el){el.textContent=cart.item_count;});
          document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart:cart,source:'ek'}}));
          show('Added '+f.getAttribute('data-title')+' to your cart.');
          btn.classList.add('is-added'); btn.textContent='Added ✓';
          setTimeout(function(){btn.classList.remove('is-added');btn.textContent='Add kit to cart';},2000);
        })
        .catch(function(err){show(err.message,true);})
        .finally(function(){btn.removeAttribute('aria-busy');btn.disabled=false;});
    });
  }
  function boot(scope){
    if(scope&&scope.matches&&scope.matches('[data-ek]')){init(scope);return;}
    [].forEach.call((scope||document).querySelectorAll('[data-ek]'),init);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){boot();}); else boot();
  document.addEventListener('shopify:section:load',function(e){boot(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mr1-tooling-matrix"] && !Shopify.designMode) return;
  try {
    
(function(){
  var NAMES={p:'steel',m:'stainless steel',k:'cast iron',n:'aluminum and non-ferrous metals',s:'titanium and superalloys',h:'hardened steel'};
  function init(root){
    if(!root || root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready','1');
    var state={mat:'all',type:'all'};
    var rows=[].slice.call(root.querySelectorAll('.ls-tm__row'));
    var groups=[].slice.call(root.querySelectorAll('.ls-tm__group'));
    var status=root.querySelector('.ls-tm__status');
    var empty=root.querySelector('.ls-tm__emptybody');
    function press(set,val){
      [].forEach.call(root.querySelectorAll('[data-set="'+set+'"]'),function(b){b.setAttribute('aria-pressed',b.getAttribute('data-val')===val?'true':'false');});
    }
    function apply(){
      var shown=0;
      rows.forEach(function(r){
        var okMat=state.mat==='all'||/^(good|ok)$/.test(r.getAttribute('data-r'+state.mat)||'');
        var okType=state.type==='all'||(' '+r.getAttribute('data-filter')+' ').indexOf(' '+state.type+' ')>-1;
        var vis=okMat&&okType; r.hidden=!vis; if(vis) shown++;
      });
      groups.forEach(function(g){ g.hidden=!g.querySelector('.ls-tm__row:not([hidden])'); });
      if(empty) empty.hidden=shown>0;
      if(state.mat==='all') root.removeAttribute('data-mat'); else root.setAttribute('data-mat',state.mat);
      var noun=shown===1?'tool':'tools';
      if(status) status.textContent= state.mat==='all'
        ? (state.type==='all'?'Showing all '+rows.length+' tools.':'Showing '+shown+' '+noun+'.')
        : shown+' '+noun+' rated good or OK for '+NAMES[state.mat]+'.';
    }
    root.addEventListener('click',function(e){
      var b=e.target.closest('[data-set]');
      if(b){ state[b.getAttribute('data-set')]=b.getAttribute('data-val'); press(b.getAttribute('data-set'),b.getAttribute('data-val')); apply(); return; }
      if(e.target.closest('[data-reset]')){ state.mat='all';state.type='all';press('mat','all');press('type','all');apply(); }
    });
    apply();
  }
  function boot(scope){
    if(scope && scope.matches && scope.matches('[data-ls-tm]')) { init(scope); return; }
    [].forEach.call((scope||document).querySelectorAll('[data-ls-tm]'),init);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){boot();}); else boot();
  document.addEventListener('shopify:section:load',function(e){boot(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-product-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const slider = document.querySelector('.product-slider');

    if (!slider) return;

    const track = slider.querySelector('.product-track');
    const next = slider.querySelector('.next');
    const prev = slider.querySelector('.prev');
    const dotsBox = slider.querySelector('.slider-dots');

    let slides = [...track.children];

    let index = 0;
    let autoplay;

    function slidesToShow() {
      if (window.innerWidth <= 575) return 1;

      if (window.innerWidth <= 991) return 2;

      return 6;
    }

    // dynamic width
    function setSlideWidth() {
      let show = slidesToShow();

      let width = track.parentElement.clientWidth / show;

      slides.forEach((slide) => {
        slide.style.width = width + 'px';
      });
    }

    // clone for infinite loop
    function cloneSlides() {
      slides.forEach((slide) => {
        let clone = slide.cloneNode(true);
        clone.classList.add('clone');
        track.appendChild(clone);
      });

      slides.forEach((slide) => {
        let clone = slide.cloneNode(true);
        clone.classList.add('clone');
        track.insertBefore(clone, track.firstChild);
      });

      slides = [...track.children];

      index = slides.length / 3;
    }

    function moveSlider(animation = true) {
      let show = slidesToShow();

      let width = slides[0].offsetWidth + 10;

      if (!animation) {
        track.style.transition = 'none';
      } else {
        track.style.transition = '.5s ease';
      }

      track.style.transform = `translateX(-${index * width}px)`;

      updateDots();
    }

    // reset after clone
    track.addEventListener('transitionend', () => {
      let original = slides.length / 3;

      if (index >= original * 2) {
        index = original;

        moveSlider(false);
      }

      if (index < original) {
        index = original * 2 - 1;

        moveSlider(false);
      }
    });

    // dots
    function createDots() {
      dotsBox.innerHTML = '';

      let total = Math.ceil(slides.length / 3 / slidesToShow());

      for (let i = 0; i < total; i++) {
        let btn = document.createElement('button');

        btn.onclick = () => {
          index = slides.length / 3 + i * slidesToShow();

          moveSlider();
        };

        dotsBox.appendChild(btn);
      }
    }

    function updateDots() {
      let dots = dotsBox.querySelectorAll('button');

      let current = Math.floor((index - slides.length / 3) / slidesToShow());

      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === current);
      });
    }

    // arrows

    next.onclick = () => {
      index++;

      moveSlider();
    };

    prev.onclick = () => {
      index--;

      moveSlider();
    };

    // resize

    window.addEventListener('resize', () => {
      setSlideWidth();

      moveSlider(false);
    });

    cloneSlides();

    setSlideWidth();

    createDots();

    moveSlider(false);
  });

  } catch(e) { console.error(e); }
})();
})();
